/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var e;!function(e){e[e.NotRequired=0]="NotRequired",e[e.Required=1]="Required",e[e.COUNT=2]="COUNT"}(e||(e={}));export{e as BaseOpacityMode};
